import React from 'react';
import './component010.less';
import UsefulLinkIcon from '../../../../../assets/Link.png';
import { RightOutlined } from '@ant-design/icons';

interface IComponent010Item {
  name: string;
  link: string;
}

interface IComponent010Props {
  title: string;
  resources: IComponent010Item[];
  className: string;
}

const Component010: React.FunctionComponent<IComponent010Props> = ({
  title,
  resources,
  className,
}) => (
  <div className={`resources-section component ${className}`}>
    <div className="section-container">
      <div className="resources-section-label">
        <img src={UsefulLinkIcon} alt="" />
        {title}
      </div>
      <div className="resources-links">
        {resources.map((itm: any, idx: number) => (
          <a
            href={itm.link}
            key={idx}
            className="resources-link"
            target="_blank"
            rel="noreferrer"
          >
            {itm.name} <RightOutlined />
          </a>
        ))}
      </div>
    </div>
  </div>
);

export default Component010;
